import React from "react";

//Decorative section edges from the Wix site. The filled part takes the colour of --divider (set on the parent/section)
const SHAPES = {
  //Triangles hanging down from the section above (home page, green into cream)
  "zigzag-down": "M0 0 L50 100 L100 0 L150 100 L200 0 L250 100 L300 0 L350 100 L400 0 L450 100 L500 0 L550 100 L600 0 L650 100 L700 0 L750 100 L800 0 L850 100 L900 0 L950 100 L1000 0 L1050 100 L1100 0 L1150 100 L1200 0 Z",
  //Triangles rising into the section above (Products banner)
  "zigzag-up": "M0 100 L50 0 L100 100 L150 0 L200 100 L250 0 L300 100 L350 0 L400 100 L450 0 L500 100 L550 0 L600 100 L650 0 L700 100 L750 0 L800 100 L850 0 L900 100 L950 0 L1000 100 L1050 0 L1100 100 L1150 0 L1200 100 Z",
  //Scalloped edge (About banner)
  scallop: "M0 0 A85.7 80 0 0 0 171.4 0 A85.7 80 0 0 0 342.9 0 A85.7 80 0 0 0 514.3 0 A85.7 80 0 0 0 685.7 0 A85.7 80 0 0 0 857.1 0 A85.7 80 0 0 0 1028.6 0 A85.7 80 0 0 0 1200 0 V100 H0 Z",
  //Rolling waves (home page & Contact banner)
  wave: "M0 80 C100 80 100 10 200 10 S300 80 400 80 S500 10 600 10 S700 80 800 80 S900 10 1000 10 S1100 80 1200 80 V100 H0 Z",
};

const Divider = ({ shape, className = "" }) => (
  <div
    className={`divider ${className}`}
    aria-hidden={"true"}
  >
    <svg
      viewBox={"0 0 1200 100"}
      preserveAspectRatio={"none"}
      focusable={"false"}
    >
      <path d={SHAPES[shape]} />
    </svg>
  </div>
);

export default Divider;
